import React from "react";
import styled from "styled-components";

import colors from "shared/styles/colors";
import { checkedColor } from "shared/styledComponents/Radio";

const StyledCheckboxContainer = styled.span`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 2px;
    border: solid 2px ${colors.grey_2};
    margin-right: 8px;

    input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
    }

    i {
        display: none;
        color: ${checkedColor};
        font-size: var(--header-4-font-size);
        font-weight: 600;
    }

    input:checked + i {
        display: block;
        border: 1px solid ${colors.grey_2};
        border-radius: 2px;
        transition: all .2s;
    }
`

// eslint-disable-next-line react/display-name, react/prop-types
export const Checkbox = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(({style, ...rest}, ref) => (
    <StyledCheckboxContainer style={style}>
        <input type="checkbox" {...rest} ref={ref} />
        <i className="ci-check" />
    </StyledCheckboxContainer>
  )
);